import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { SiteFooter } from "@/components/site-footer";

export function LegalLayout({
  kicker,
  title,
  updated,
  children,
}: {
  kicker: string;
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-dvh bg-background text-foreground font-mono">
      <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur">
        <div className="mx-auto max-w-[1100px] px-6 md:px-10 h-14 flex items-center justify-between text-[11px] tracking-[0.2em] uppercase">
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-muted-foreground">
            <Link to="/" className="hover:text-foreground transition">[ HOME ]</Link>
            <span aria-hidden>/</span>
            <span className="text-foreground">[ {kicker} ]</span>
          </nav>
          <Link to="/" className="text-muted-foreground hover:text-foreground transition">
            ← BACK
          </Link>
        </div>
      </header>

      <main id="main" tabIndex={-1} className="mx-auto max-w-[1100px] px-6 md:px-10 py-20 md:py-28">
        <p className="text-[10px] tracking-[0.3em] uppercase text-muted-foreground">[ {kicker} ]</p>
        <h1 className="mt-4 font-display text-[clamp(2rem,4.4vw,3.5rem)] leading-[1.02] tracking-[-0.03em]">
          {title}
        </h1>
        <p className="mt-6 text-xs tracking-[0.2em] uppercase text-muted-foreground">
          Last updated · {updated}
        </p>

        <div className="mt-16 space-y-12 text-[14px] leading-[1.7] text-foreground/90">
          {children}
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}

export function LegalSection({
  label,
  title,
  children,
}: {
  label: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section className="border-l-2 border-foreground/15 pl-6 md:pl-10">
      <p className="text-[10px] tracking-[0.3em] uppercase text-muted-foreground">[ {label} ]</p>
      <h2 className="mt-3 font-display text-2xl md:text-3xl tracking-tight text-foreground">
        {title}
      </h2>
      <div className="mt-5 space-y-4 max-w-[70ch]">{children}</div>
    </section>
  );
}
